/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for the lecturer broadcasting a message to the whole 1:N cohort (P8c).
 */
export interface OralExamBroadcastMessageRequest {
  message: string;
}
